/* sb-dc-hints.js - hides the editor's onboarding hint pills.

   2026-09-03, user: the little dark pills that greet a customer on the first
   screen ("Drop a logo or photo anywhere on the screen to upload it", the
   DROP IMAGE / product labels) are noise - take them out.

   They are drawn by the app bundle (sb-dc-app.js, 647 KB), so there is no
   class of ours to switch off and no sensible way to patch that file. This
   matches them by their words instead, which is stable enough: the copy is
   English and fixed, and if it ever changes the worst case is that a pill
   comes back, not that anything breaks.

   Safety rails, because matching on text is blunt:
     - only small elements are ever hidden (a pill, not a panel), and nothing
       that holds a button, a link or a form control;
     - the match must be the element's whole text, not a fragment;
     - #root, the artboard and the canvas are never touched.

   To add or drop a phrase later, edit PHRASES, or from the console:
   __dcHideHints.add(/some words/i) - it takes effect on the next tick. */
(function () {
  'use strict';

  var PHRASES = [
    /^drop a logo or photo anywhere on the screen to upload it\.?$/i,
    /^drop image$/i,
    /^drop your image here\.?$/i,
    /^상품$/
  ];

  var MAX_W = 560;      // a pill, not a panel
  var MAX_H = 120;
  var SKIP = { CANVAS: 1, SCRIPT: 1, STYLE: 1, BUTTON: 1, A: 1, INPUT: 1, TEXTAREA: 1, SELECT: 1, SVG: 1 };

  function matches(t) {
    t = (t || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 90) return false;
    for (var i = 0; i < PHRASES.length; i++) if (PHRASES[i].test(t)) return true;
    return false;
  }

  function safe(el) {
    if (!el || el.nodeType !== 1) return false;
    if (SKIP[el.tagName]) return false;
    if (el.id === 'root' || el.id === 'sbdc-gate') return false;
    if (el.querySelector('button,a,input,textarea,select,canvas')) return false;
    var r = el.getBoundingClientRect();
    if (r.width > MAX_W || r.height > MAX_H) return false;
    return true;
  }

  /* The words usually sit in a <span> inside the pill that carries the dark
     background; hiding the span alone would leave an empty pill. Climb while
     the parent says nothing else. */
  function pillOf(el) {
    var top = el;
    for (var i = 0; i < 3; i++) {
      var p = top.parentElement;
      if (!p || p === document.body) break;
      if (!matches(p.textContent)) break;
      if (!safe(p)) break;
      top = p;
    }
    return top;
  }

  function sweep() {
    var all = document.querySelectorAll('div,span,p,section,aside,label,strong,em,small');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.dataset && el.dataset.sbdcHint) continue;
      if (el.children.length > 1) continue;            // a leaf, or a leaf in a wrapper
      if (!matches(el.textContent)) continue;
      if (!safe(el)) continue;
      var pill = pillOf(el);
      pill.dataset.sbdcHint = 'hidden';
      pill.style.setProperty('display', 'none', 'important');
    }
  }

  var timer = setInterval(function () { try { sweep(); } catch (e) {} }, 400);
  window.addEventListener('pagehide', function () { clearInterval(timer); });

  window.__dcHideHints = {
    add: function (re) { PHRASES.push(re); },
    list: function () { return PHRASES.slice(); },
    sweep: sweep
  };
})();
